import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import TopBar from "@/components/TopBar";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { NotifIcon, notifLink } from "@/lib/notifications";
import { BellOff } from "lucide-react";

const Row = ({ n }) => {
  const href = notifLink(n);
  const body = (
    <div className={`flex items-start gap-3 p-4 ${!n.read ? "bg-amber-50/60" : "bg-white"}`}>
      <div className="w-9 h-9 rounded-full bg-amber-100 text-amber-800 grid place-items-center shrink-0"><NotifIcon kind={n.kind}/></div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">{n.title}</div>
        <div className="text-sm text-slate-600">{n.body}</div>
        <div className="text-[11px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString()}</div>
      </div>
      {!n.read && <span className="w-2 h-2 rounded-full bg-amber-500 mt-2" aria-label="unread"/>}
    </div>
  );
  return href
    ? <Link to={href} data-testid={`notif-row-${n.id}`} className="block hover:brightness-[0.98]">{body}</Link>
    : <div data-testid={`notif-row-${n.id}`}>{body}</div>;
};

const Notifications = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/notifications").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); const iv = setInterval(load, 15000); return () => clearInterval(iv); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const rows = filter === "unread" ? items.filter((n) => !n.read) : items;

  return (
    <div className="min-h-screen bg-slate-50 pb-16">
      <TopBar/>
      <main className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
          <h1 className="font-display text-2xl font-extrabold" data-testid="notifications-title">Notifications</h1>
          <Button variant="outline" size="sm" className="rounded-full" onClick={markAll} data-testid="notifications-mark-all">Mark all read</Button>
        </div>
        <Tabs value={filter} onValueChange={setFilter} className="mb-3">
          <TabsList className="rounded-full bg-slate-100">
            <TabsTrigger value="all" className="rounded-full" data-testid="notif-filter-all">All</TabsTrigger>
            <TabsTrigger value="unread" className="rounded-full" data-testid="notif-filter-unread">Unread</TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="rounded-2xl border border-slate-200 overflow-hidden divide-y divide-slate-100" data-testid="notifications-list">
          {rows.length === 0 && (
            <div className="p-10 text-center text-sm text-slate-500 bg-white" data-testid="notifications-empty">
              <BellOff className="w-6 h-6 mx-auto mb-2 text-slate-300"/> Nothing here yet. Requests, offers, acceptances and expiries will show up here.
            </div>
          )}
          {rows.map((n) => <Row key={n.id} n={n}/>)}
        </div>
      </main>
    </div>
  );
};

export default Notifications;
